import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * Scrolls the window to top on every route change. Without this, a user
 * navigating from a scrolled long list (Actions, Consumer 360) to another
 * page lands mid-scroll — disorienting.
 *
 * Full forward/back scroll *restoration* (remembering per-entry scroll
 * offset) requires react-router v7's data router (`createBrowserRouter`).
 * Our app uses the legacy `<BrowserRouter>`, so this simpler reset is the
 * pragmatic replacement. Revisit if we migrate to the data router.
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);
  return null;
};

export default ScrollToTop;
